import React from "react";
import { object } from "prop-types";
import { formatDistance } from "date-fns";
import { bn } from "date-fns/locale";
import get from "lodash/get";

import "./liveText.m.css";

const LiveText = ({ story }) => {
  const isClosed = get(story, ["metadata", "is-closed"], false);
  const banglaDate = get(story, ["last-published-at"], null);

  return isClosed ? (
    <div styleName="live-text">
      লাইভ {banglaDate ? formatDistance(new Date(banglaDate), new Date(), { locale: bn, addSuffix: true }) : ""}
    </div>
  ) : (
    <div styleName="live-text open-blog ">লাইভ</div>
  );
};

LiveText.propTypes = {
  story: object.isRequired
};

export default LiveText;
